import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const FLAG_EMOJI = { GB: "🇬🇧", ES: "🇪🇸", FR: "🇫🇷", DE: "🇩🇪", JP: "🇯🇵", BR: "🇧🇷" };

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="flex items-center gap-1.5 px-2 py-1.5 rounded-lg bg-white/5 hover:bg-white/10 text-slate-400 hover:text-white transition-all text-xs"
        data-testid="language-switcher"
      >
        <Globe className="w-3.5 h-3.5" />
        <span className="hidden sm:inline">{current.code.toUpperCase()}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-[#0B0F19] border-white/10 min-w-[140px]">
        {LANGUAGES.map(lang => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            className={`cursor-pointer flex items-center gap-2 ${i18n.language === lang.code ? "text-amber-400" : ""}`}
            data-testid={`lang-${lang.code}`}
          >
            <span>{FLAG_EMOJI[lang.flag]}</span>
            <span>{lang.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
